
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductSpecificationsBooksGrid extends Serenity.EntityGrid<ProductSpecificationsBooksRow, any> {
        protected getColumnsKey() { return ProductSpecificationsBooksColumns.columnsKey; }
        protected getDialogType() { return ProductSpecificationsBooksDialog; }
        protected getIdProperty() { return ProductSpecificationsBooksRow.idProperty; }
        protected getInsertPermission() { return ProductSpecificationsBooksRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductSpecificationsBooksRow.localTextPrefix; }
        protected getService() { return ProductSpecificationsBooksService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}